import CustomModal from "../CustomModal";

const EnableStaffModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  handleEnableUser,
}) => {
  // Don't render modal if no selectedAdmin
  if (!selectedAdmin) {
    return null;
  }

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Enable Admin Modal"
      className="delete-modal"
    >
      <div className="delete-modal-inner">
        <img
          src={`${process.env.PUBLIC_URL}/images/enable-modal-img.png`}
          alt="Enable user icon"
        />
        <p>Are you sure you want to enable this Staff profile?</p>
        <div className="delete-modal-button">
          <button
            className="delete-btn1"
            style={{ backgroundColor: "#0473DB" }}
            onClick={handleEnableUser}
          >
            Enable
          </button>
          <button className="delete-btn2" onClick={onRequestClose}>
            Cancel
          </button>
        </div>
      </div>
    </CustomModal>
  );
};

export default EnableStaffModal;
